(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('sortDropdown', {
            templateUrl: 'app/components/sort-dropdown/sort-dropdown.html',
            controller: sortDropdownController,
            bindings: {
                name: '@',
                options: '<',
                onChange: '&',
                value: '=',
                hideIcon: '<?',
            }
        })
        .directive("changeItemsPerPage", function () {
            return {
                restrict: "A",
                link: function (scope) {
                    scope.$watch("$ctrl.value", function (newValue) {
                        if (scope.$ctrl.onChange) {
                            scope.$ctrl.onChange({ newValue: newValue });
                        }
                    });
                },
            };
        });

    /** @ngInject */
    function sortDropdownController(systemConstants, $window, $translate) {
        var $ctrl = this;

        $ctrl.filteredOptions = [];

        $ctrl.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;

        $ctrl.$onInit = function () {
            $ctrl.selectedOption = findOption($ctrl.value) || ($ctrl.options && $ctrl.options[0]);

            if ($ctrl.selectedOption) {
                $ctrl.onChange({ newValue: $ctrl.selectedOption });
            }

            if ($ctrl.options) {
                $ctrl.filteredOptions = $ctrl.options.filter(function (item) {
                    return item.id !== 0;
                });
            }
        };

        $ctrl.selectOption = function (option) {
            $ctrl.selectedOption = option;
            $ctrl.onChange({ newValue: option });
        };

        function findOption(value) {
            if (!$ctrl.options) return null;
            for (var i = 0; i < $ctrl.options.length; i++) {
                if (!angular.isObject(value) && $ctrl.options[i].value === value) {
                    return $ctrl.options[i];
                } else if (angular.isObject(value) && $ctrl.options[i].value === value.value) {
                    return $ctrl.options[i];
                }
            }
            return null;
        }

        $ctrl.getButtonLabel = function () {
            return $ctrl.selectedOption.label;
        };

        $ctrl.getHeaderText = function () {
            return $translate.instant('flyers.list.ordenation');
        };

        $ctrl.isSelected = function (option) {
            return $ctrl.selectedOption && $ctrl.selectedOption.label === option.label;
        };
    }
})();
